/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import autobind from "autobind-decorator";

import {FileUploadFieldEditor} from "./FileUploadFieldEditor";
import {service as FileUploadService} from "../../../Services/FileUploadService";
import {FileEditorEnhance} from "../../../Components/Common/Files/FileEditorEnhance";

@FileEditorEnhance
export class FileUploadFieldEditorWithOverlay extends FileUploadFieldEditor {
    @autobind
    reloadData() {
        FileUploadService.GetFileUpload(this.state.fileUpload.fileUploadId)
            .then((x) => this.setState({fileUpload: x.result}))
            .catch((err) => this.setState({fileUpload: null}));
    }

    @autobind
    getTagCode() {
        const { CustomData } = this.props;
        let tagCode = null;
        if (CustomData && CustomData?.tagCode) {
            tagCode = CustomData.tagCode;
        }
        return tagCode;
    }

    @autobind
    processFile(file) {
        this.setState({uploadProgress: 0, displayUpload: true}, () => {
            const { OnUpdate } = this.props;
            const contextNodeIds = this.getContextNodeIds() ?? [];
            const surveyTypeId = this.getSurveyTypeId();
            const tagCode = this.getTagCode();

            FileUploadService.UploadFile(
                file.name,
                file,
                contextNodeIds,
                (a, b) => this.setState({uploadProgress: ((a / b) * 100)}),
                surveyTypeId,
                tagCode
            )
                .then((file) => {
                    this.setState({uploadProgress: 0, fileUpload: file, displayUpload: false}, () => {
                        OnUpdate(file.fileUploadId);
                        this.props.FileEdit?.DisplayEditOverlay?.(file);
                    });
                })
                .catch((x) => {
                    this.setState({uploadProgress: 0});
                });
        });
    }
}
